import { Component, inject } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../../../store/app/app.selectors';
import { UserOnboardingRequest } from '../../../../_interfaces/user.interface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../../_services/user-service/user.service';
import { ToastService } from '../../../../_services/toast-service/toast.service';
import { SetUserStateFromReloadAppState } from '../../../../store/app/app.actions';

@Component({
  selector: 'app-set-up-tutorial-modal',
  imports: [AsyncPipe, CommonModule],
  templateUrl: './set-up-tutorial-modal.component.html',
  styleUrl: '../../../../../static/styles/components/set-up-tutorial-modal.component.scss',
})
export class SetUpTutorialModalComponent {
  readonly userService = inject(UserService);
  readonly ngbActiveModal = inject(NgbActiveModal);
  readonly toastService = inject(ToastService);
  readonly store = inject(Store);

  readonly userProfile$ = this.store.select(AppSelectors.userDetails);
  protected noApiRequired: boolean = false;
  protected currentStep: number = 1;
  protected totalSteps: number = 6;
  protected animationDirection: 'forward' | 'backward' | '' = '';

  steps = [
    {
      imgSrc: 'assets/set-up-tutorial/set-up-1.svg',
      title: 'Welcome to Paystashio',
      description: '',
    },
    {
      imgSrc: 'assets/set-up-tutorial/set-up-2.svg',
      title: 'Upload employees',
      description: 'Bulk upload or manually add your employees to start issuing your employee cards.',
    },
    {
      imgSrc: 'assets/set-up-tutorial/set-up-3.svg',
      title: 'Create card top-up rules',
      description: 'Set limits and create rules for your employees cards.',
    },
    {
      imgSrc: 'assets/set-up-tutorial/set-up-4.svg',
      title: 'Fund your account',
      description: 'EFT funds into your Paystashio account for your employees to start spending.',
    },
    {
      imgSrc: 'assets/set-up-tutorial/set-up-5.svg',
      title: 'Link to your accounting software',
      description: 'Connect with your accounting software for enhanced management and efficiency.',
    },
    {
      imgSrc: 'assets/set-up-tutorial/set-up-6.svg',
      title: 'Create categories',
      description: 'Create categories to automate receipt capture and simplify spend management.',
    },
  ];

  // Close modal
  close() {
    this.ngbActiveModal.close();
  }

  // Go to the next step
  nextStep() {
    if (this.currentStep < this.totalSteps) {
      this.animationDirection = 'forward';
      this.currentStep++;
      // Reset animation class after animation completes
      setTimeout(() => (this.animationDirection = ''), 300);
    }
  }

  // Go to the previous step
  prevStep() {
    if (this.currentStep > 1) {
      this.animationDirection = 'backward';
      this.currentStep--;
      // Reset animation class after animation completes
      setTimeout(() => (this.animationDirection = ''), 300);
    }
  }

  finishSetup() {
    const data: UserOnboardingRequest = {
      step: this.currentStep,
      completed: true,
    };

    // Call the updateUserOnboardingStatus method with the onboarding ID and data
    this.userService.updateUserOnboardingStatus(data).subscribe({
      next: () => {
        this.store.dispatch(new SetUserStateFromReloadAppState());
        this.ngbActiveModal.dismiss();
      },
      error: (err) => {
        this.toastService.show(err, 'iconoir-xmark');
      },
    });
  }
}
